// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3BiKB","title":"AfterBackImages_title__1z9sb","images":"AfterBackImages_images__3WH_7"};